import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: API_URL,
});

export const entriesAPI = {
  // Get current week entries
  getWeekEntries: (date) => api.get('/api/entries', { params: date ? { date } : {} }),

  // Get entries for specific company
  getCompanyEntries: (companyId, date) =>
    api.get(`/api/entries/company/${companyId}`, { params: date ? { date } : {} }),

  // Create new entry
  createEntry: (data) => api.post('/api/entries', data),

  // Update entry
  updateEntry: (id, data) => api.put(`/api/entries/${id}`, data),

  // Delete entry
  deleteEntry: (id) => api.delete(`/api/entries/${id}`),

  // Get weekly summary
  getWeeklySummary: (date) => api.get('/api/entries/weekly-summary', { params: date ? { date } : {} }),

  // Get hours for an entry
  getEntryHours: (id) => api.get(`/api/entries/hours/${id}`),
};

export const companiesAPI = {
  // Get all companies
  getAll: () => api.get('/api/companies'),

  // Get specific company
  getOne: (id) => api.get(`/api/companies/${id}`),

  // Create company
  create: (data) => api.post('/api/companies', data),

  // Update company
  update: (id, data) => api.put(`/api/companies/${id}`, data),

  // Delete company
  delete: (id) => api.delete(`/api/companies/${id}`),
};

export const archiveAPI = {
  // Search archived entries
  search: (params) => api.get('/api/archive/entries', { params }),
};

export const emailAPI = {
  // Get system status
  getStatus: (date) => api.get('/api/status', { params: date ? { date } : {} }),

  // Send report manually
  sendReport: (format = 'all') => api.post('/api/send-report', { format }),

  // Send report for a single company
  sendCompanyReport: (companyId, format = 'all') => api.post(`/api/send-report/${companyId}`, { format }),

  // Get email send history
  getHistory: (limit = 20) => api.get('/api/email-history', { params: { limit } }),
};

export const summaryAPI = {
  // Get weekly summary
  getWeeklySummary: (date) => api.get('/api/weekly-summary', { params: date ? { date } : {} }),
};

export default api;
